











import { Vue, Component } from "@/shared/vuepack";

@Component
export default class AvidiaFooterInvestment extends Vue {
}
